// extracted by mini-css-extract-plugin
module.exports = {"grid":"styles__grid___32yzf","gridRowSpacing":"styles__gridRowSpacing___3E6FG","gridColSpacing":"styles__gridColSpacing___lZ8KE"};